/**
 * Detects if user is signed in
 * @returns true if user is signed in
 */
export const getIsSignedIn = (): boolean =>
    !!(window && window.localStorage.getItem('pylot_token'))
